import * as React from 'react';
import * as Dialog from '@naan/primitives/modals';
import { observer } from 'mobx-react';
import { ExcerptData } from 'tikka/client/catalog-types';
import { Button } from '@naan/primitives/button';
import { ListIcon } from '@naan/icons/list-icon';
// import { Divider } from '@naan/primitives/divider';
import __ from '@core/lib/localization';
// import { VSpacer } from '@naan/primitives/spacer';
import { AppFactory } from 'app/app-factory';
import { VocablistMarkdown } from '@naan/primitives/text/soundbite-vocablist-markdown';
import { track } from 'app/track';

export const VocabularyModal = observer(
  ({ excerpt, onDismiss }: { excerpt: ExcerptData; onDismiss: () => void }) => {
    return (
      <Dialog.Container open onDismiss={onDismiss}>
        <Dialog.Heading>
          {__('Vocabulary', 'soundbites.vocabulary')}
        </Dialog.Heading>
        <Dialog.Body>
          {/* <Divider /> */}
          {/* <VSpacer size={4} /> */}
          <VocablistMarkdown source={excerpt.vocabulary} />
        </Dialog.Body>
        <Dialog.ButtonsContainer>
          <Dialog.Button
            label={'Close'}
            presentation="grayLight"
            type="button"
            onClick={onDismiss}
            fullWidth
          />
        </Dialog.ButtonsContainer>
      </Dialog.Container>
    );
  }
);

export const Vocabulary = observer(({ excerpt }: { excerpt: ExcerptData }) => {
  const handleVocabularyClick = React.useCallback(() => {
    track('soundbite__vocab_shown');
    AppFactory.dialogPresenter.present(onDismiss => (
      <VocabularyModal excerpt={excerpt} onDismiss={onDismiss} />
    ));
  }, [excerpt]);

  if (!excerpt.vocabulary) {
    return null;
  }

  return (
    <Button
      size="small"
      label={__('Vocabulary', 'soundbites.vocabulary')}
      presentation="grayLight"
      leftIcon={<ListIcon />}
      onClick={handleVocabularyClick}
    />
  );
});
